import { CheckCircle } from '@phosphor-icons/react';

export default CheckCircle;
